import { useDispatch, useSelector } from "react-redux";
import "./style.css";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";

import { DeleteEvaluatorInfo } from "../../../Redux/Reducers/Manager/EvaluatorInfo";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";

const EvaluatorTable = () => {
  const { userId } = useParams();
  const EvaluatorInfoRow = useSelector(
    (state) => state.EvaluatorInfo?.EvaluatorInfoRow
  );

  const [EV_NT_EvaluatorInfoId, setEV_NT_EvaluatorInfoId] = useState(null);
  const state = useSelector((state) => {
    return {
      EvaluatorInfoRow: state.EvaluatorInfo.AddEvaluatorInfoRow,
    };
  });
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "roundName",
      ShowStatus: true,
      NmaeColumn: "الدورة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "userFullName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: " الحقل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subjectName",
      ShowStatus: true,
      NmaeColumn: "الموضوع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "evaluatorAppointmentLetterAttached",
      ShowStatus: true,
      NmaeColumn: "مرفق كتاب تعيين المحكم",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      typeColumn: "file",
    },
    {
      KeyName: "note",
      ShowStatus: true,
      NmaeColumn: "ملاحظات",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
    },
  ];

  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        let data = JSON.parse(e.target.value);
        console.log(data, "sdsdsdsdsdsdsds");

        Swal.fire({
          title: "  هل انت متأكد من الحذف ؟",
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "إلغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            var result = await dispatch(
              DeleteEvaluatorInfo({
                eV_ST_EvaluatorInfoId: data.eV_ST_EvaluatorInfoId,
              })
            );
            console.log(result, "result.payload.code");
            if (result.payload == "success") {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم حفظ المعلومات بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              dispatch(setRefreshTable({ tableId: "EvaluatorInfo" }));
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      ShowStatus: true,
    },
  ];

  const RequestsManagerColumns = [];
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"eV_ST_EvaluatorInfoId"}
        valueButtonAction={"eV_ST_EvaluatorInfoId"}
        URL={`api/EvaluatorInfo/GetEvaluatorInfoByUserId`}
        UrlBody={{
          // roundYearId: props.roundActive,
          uS_UserGuid: userId,
        }}
        staticKeyEdite={staticKeyEdite}
        tableId="EvaluatorInfo"
        accessor={RequestAccessor}
        titelTable={"تعيين العضو"}
        selectRowNumber={true}
        checkBoksColumName=""
        sort={true}
        pagination={true}
        // EvaluatorAppointmentLetterAttached
        fileStoreName="EvaluatorAppointmentLetterAttached"
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};
export default EvaluatorTable;
